export default "__VITE_ASSET__Bq$vGv19__"